// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';

import TransparentBlogCard from 'examples/Cards/BlogCards/TransparentBlogCard';

import data from 'csdd_data/newsAndInsights';

import slug from 'slug';
import MKPagination from 'components/MKPagination';
import { ChevronLeftSharp, ChevronRightSharp } from '@mui/icons-material';
import { useState } from 'react';
import { AppBar, Tab, Tabs } from '@mui/material';
import YoutubeVideos from './YoutubeVideos';
import videos from 'csdd_data/latestVideos';
import MKTypography from 'components/MKTypography';

function NewsContent() {
  const youtubeData = videos.map(({ id, videoId }) => (
    <Grid item xs={12} md={6} lg={4} sx={{ mb: { xs: 3, lg: 0 } }} key={id}>
      <YoutubeVideos videoId={videoId} />
    </Grid>
  ));
  const [activeTab, setActiveTab] = useState(0);

  const handleTabType = (event, newValue) => setActiveTab(newValue);
  return (
    <MKBox component='section'>
      <Container id='start' sx={{ py: 5 }}>
        <Grid container item justifyContent='center' xs={12} lg={4} mx='auto'>
          <AppBar position='static'>
            <Tabs value={activeTab} onChange={handleTabType}>
              <Tab label='News & Insights' />
              <Tab label='Latest Videos' />
            </Tabs>
          </AppBar>
        </Grid>
      </Container>
      <Container sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
        {data.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            News is not available at the moment.
          </MKTypography>
        ) : (
          <>
            <Grid container spacing={3}>
              {data.map((article) => {
                return (
                  <Grid item xs={12} sm={6} lg={4} key={article.title}>
                    <TransparentBlogCard
                      image={article.headerImage}
                      title={article.title}
                      description={article.description}
                      action={{
                        type: 'internal',
                        route: `/news/${slug(article.title)}`,
                        color: 'error',
                        label: 'read more',
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Container sx={{ mt: 10 }}>
              <MKPagination placement='center'>
                <MKPagination item>
                  <ChevronLeftSharp color='warning' />
                </MKPagination>
                <MKPagination item active>
                  1
                </MKPagination>
                <MKPagination item>2</MKPagination>
                <MKPagination item>3</MKPagination>
                <MKPagination item>
                  <ChevronRightSharp color='warning' />
                </MKPagination>
              </MKPagination>
            </Container>
          </>
        )}
      </Container>
      <Container
        sx={{
          mt: { xs: 8, lg: 8 },
          display: activeTab === 1 ? 'block' : 'none',
        }}
      >
        {videos.length === 0 ? (
          <MKTypography textAlign='center' color='warning'>
            Latest videos is not available at the moment.
          </MKTypography>
        ) : (
          <>
            <Grid container spacing={2}>
              {youtubeData}
            </Grid>
            <Container sx={{ mt: 10 }}>
              <MKPagination placement='center'>
                <MKPagination item>
                  <ChevronLeftSharp color='warning' />
                </MKPagination>
                <MKPagination item active>
                  1
                </MKPagination>
                <MKPagination item>2</MKPagination>
                <MKPagination item>3</MKPagination>
                <MKPagination item>
                  <ChevronRightSharp color='warning' />
                </MKPagination>
              </MKPagination>
            </Container>
          </>
        )}
      </Container>
    </MKBox>
  );
}

export default NewsContent;
